import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'

import {
  AddressSection,
  CustomerBillingSection,
  CompanyContractSection,
  OptionSection,
  PaymentMethodSection,
  PreferenceSection,
  PrimarySection,
  SecondarySection,
  SubscriptionSection,
} from './Section'

import Dialogs from './Popup'
import LoginSection from '@abra/frames/LoginSection'
import FormSpeedDial from '@abra/elements/speedDial/Form'
import OrderLimitationSection from '@abra/panels/OrderLimitation'

const User = ({ isManagingRecord, displayResetPassord, DISPLAY_PREF, onResetSmsPassword, onResetEmailPassword, confirmWelcomeEmail }) => {
  const actions = [
    { name: I18n.t('action.reset_password'), iconName: 'sms', onClick: onResetSmsPassword, hidden: !displayResetPassord },
    { name: I18n.t('action.reset_password'), iconName: 'alternate_email', onClick: onResetEmailPassword, hidden: !displayResetPassord },
    { name: I18n.t('email.welcome.label', { count: 1 }), iconName: 'alternate_email', onClick: confirmWelcomeEmail, hidden: !!displayResetPassord }
  ]

  return (
    <>
      <Dialogs />
      <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
        <Grid container rowSpacing={3}>
          <Grid size={12}><FormHeader goBackPath={'/client'} /></Grid>
          <Grid size={12}>
            <GridStepper groupsCount={[11]} activeStep={0} orientation="vertical">
              <Step> <PrimarySection /> </Step>
              <Step> <SecondarySection disabled={!isManagingRecord} /> </Step>
              <Step> <AddressSection disabled={!isManagingRecord} /> </Step>
              <Step> <OptionSection /> </Step>
              <Step> <OrderLimitationSection model='userorderlimit' disableTarget /> </Step>
              <Step> {!!DISPLAY_PREF && <PreferenceSection />}</Step>
              <Step> <CompanyContractSection /> </Step>
              <Step> <SubscriptionSection disabled={!isManagingRecord} />  </Step>
              <Step> <CustomerBillingSection disabled={!isManagingRecord} /> </Step>
              <Step> <PaymentMethodSection disabled={!isManagingRecord} /> </Step>
              <Step> <LoginSection tableProps={{ enableGlobalActions: false }} /> </Step>
            </GridStepper>
          </Grid>
        </Grid>
      </Box>
      <FormSpeedDial actions={actions} />
    </>
  );
}


export default React.memo(User)

